import { useSelector } from "react-redux";
import ProductForm from "./components/ProductForm";
import ProductItem from "./components/ProductItem";

export default function ProductWrapper() {
  const products = useSelector((state) => state.product);

  return (
    <div className="productWrapper">
      {/* products container */}
      <div className="productContainer" id="lws-productContainer">
        {/* product item */}
        {products.length ? (
          products.map((product) => (
            <ProductItem key={product.id} product={product} />
          ))
        ) : (
          <h4>No Product Found</h4>
        )}
      </div>
      {/* products container ends */}
      <ProductForm />
    </div>
  );
}
